import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-[#F5F0E6] py-20 md:py-28" data-id="element-86">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6
    }} className="max-w-3xl mx-auto px-6" data-id="element-87">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1A1A1A] tracking-tight mb-8 leading-tight" data-id="element-88">
          The CrownControl™ 180-Day Guarantee
        </h2>

        <p className="text-lg text-[#4B5563] leading-relaxed mb-10" data-id="element-89">
          We built this guarantee for one reason: we know this protocol produces
          results for men who commit to it. If you use it correctly and don't
          see improvement, you shouldn't keep it.
        </p>

        <p className="text-lg font-medium text-[#1A1A1A] mb-8" data-id="element-90">
          Here are the terms, plainly:
        </p>

        <div className="space-y-5 mb-12" data-id="element-91">
          <div className="flex items-start gap-4" data-id="element-92">
            <CheckCircleIcon className="w-6 h-6 text-[#C8A04A] mt-0.5 flex-shrink-0" data-id="element-93" />
            <p className="text-[#4B5563] leading-relaxed" data-id="element-94">
              Use CrownControl™ for a minimum of 3 sessions per week for 180
              consecutive days.
            </p>
          </div>
          <div className="flex items-start gap-4" data-id="element-95">
            <CheckCircleIcon className="w-6 h-6 text-[#C8A04A] mt-0.5 flex-shrink-0" data-id="element-96" />
            <p className="text-[#4B5563] leading-relaxed" data-id="element-97">
              Take a baseline photo of your hairline and crown before you start.
            </p>
          </div>
          <div className="flex items-start gap-4" data-id="element-98">
            <CheckCircleIcon className="w-6 h-6 text-[#C8A04A] mt-0.5 flex-shrink-0" data-id="element-99" />
            <p className="text-[#4B5563] leading-relaxed" data-id="element-100">
              Take a follow-up photo at month 3 and again at month 6 using the
              same lighting and angle.
            </p>
          </div>
          <div className="flex items-start gap-4" data-id="element-101">
            <CheckCircleIcon className="w-6 h-6 text-[#C8A04A] mt-0.5 flex-shrink-0" data-id="element-102" />
            <p className="text-[#4B5563] leading-relaxed" data-id="element-103">
              If after 180 days of consistent use you see no meaningful
              improvement in hair density, contact our support team.
            </p>
          </div>
          <div className="flex items-start gap-4" data-id="element-104">
            <CheckCircleIcon className="w-6 h-6 text-[#C8A04A] mt-0.5 flex-shrink-0" data-id="element-105" />
            <p className="text-[#4B5563] leading-relaxed" data-id="element-106">
              Email us your baseline and month-6 photos.
            </p>
          </div>
          <div className="flex items-start gap-4" data-id="element-107">
            <CheckCircleIcon className="w-6 h-6 text-[#C8A04A] mt-0.5 flex-shrink-0" data-id="element-108" />
            <p className="text-[#4B5563] leading-relaxed" data-id="element-109">
              We will issue a full refund — no restocking fee, no runaround.
            </p>
          </div>
          <div className="flex items-start gap-4" data-id="element-110">
            <CheckCircleIcon className="w-6 h-6 text-[#C8A04A] mt-0.5 flex-shrink-0" data-id="element-111" />
            <p className="text-[#4B5563] leading-relaxed" data-id="element-112">
              The photos aren't a gotcha. They're how we verify the protocol was
              used — and they're the clearest way for you to track real progress
              too.
            </p>
          </div>
        </div>

        <div className="border-t border-[#D4C9A8] pt-8" data-id="element-113">
          <p className="text-xl font-bold text-[#1A1A1A] leading-relaxed mb-3" data-id="element-114">
            If you've done your part and haven't seen meaningful improvement, we
            don't want your money.
          </p>
          <p className="text-lg text-[#4B5563] leading-relaxed" data-id="element-115">
            We're confident in this device. Confident enough to stand behind it
            for six months.
          </p>
        </div>
      </motion.div>
    </section>;
}